<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
-->

<template>
  <PrimePaginator
    :first="first"
    :rows="elementPerPage"
    :total-records="totalRecords"
    template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
    @page="changePage($event)"
  >
    <template v-if="rowPerPageOptionsAsNumbers.length > 0" #end>
      <PrimeSelect
        :model-value="elementPerPage"
        :options="rowPerPageOptionsAsNumbers"
        :aria-label="$t?.('pagination.rowsPerPage') || 'Rows per page'"
        @update:model-value="changeElementPerPage($event)"
      />
    </template>
  </PrimePaginator>
</template>

<script>
import { useStorage } from "@vueuse/core";
import { mapState } from "pinia";
import { useConfigStore } from "@/stores/config.js";
import { usePaginatorStore } from "@/stores/paginator.js";
import Paginator from "primevue/paginator";
import Select from "primevue/select";

export default {
  name: "PaginatorComponent",
  components: {
    PrimePaginator: Paginator,
    PrimeSelect: Select,
  },
  props: {
    displayedElements: {
      type: Array,
      default: () => [],
    },
    totalRecords: {
      type: Number,
      default: 0,
    },
  },
  emits: ["changePage", "changeElementPerPage"],
  data() {
    const storedElementPerPage = useStorage(
      "elementPerPage",
      useConfigStore().DEFAULT_ELEMENT_PER_PAGE,
    );
    return {
      elementPerPage: Number(storedElementPerPage.value),
    };
  },
  computed: {
    ...mapState(usePaginatorStore, ["first"]),
    ...mapState(useConfigStore, ["ROW_PER_PAGE_OPTIONS"]),
    rowPerPageOptionsAsNumbers() {
      return this.ROW_PER_PAGE_OPTIONS.map(Number);
    },
  },
  methods: {
    changeElementPerPage(event) {
      const storedElementPerPage = localStorage.getItem("elementPerPage");
      const parsedElementPerPage = storedElementPerPage
        ? parseInt(storedElementPerPage)
        : null;
      const isSameElementPerPage = parsedElementPerPage === event;
      if (!isSameElementPerPage) {
        this.elementPerPage = event;
        localStorage.setItem("elementPerPage", this.elementPerPage);
        this.$emit("changeElementPerPage");
      }
    },
    changePage(event) {
      // event.first is already the skipCount (index of first record)
      usePaginatorStore().setFirst(event.first);
      this.$emit("changePage", event.first);
    },
  },
};
</script>

<style scoped></style>
